import { action, computed, observable } from 'mobx';
import API from '../util/ApiUtil';
import BaseLoginStore from './BaseLoginStore';
import RootStore from './RootStore';

export interface EmailLoginPasswords {
  oldPassword: string;
  password: string;
  confirmPassword: string;
}

export default class PasswordChangeStore extends BaseLoginStore {
  @observable accessor emailLoginPasswords: EmailLoginPasswords = { oldPassword: '', password: '', confirmPassword: '' };
  @observable accessor softAuth: boolean = false;
  @observable accessor isChangePasswordModalOpen: boolean = false;

  constructor(rootStore: RootStore) {
    super(rootStore);
  }

  public init = () => {
    this.resetPasswordForm();
    this.getInitialPasswordChangeProps();
  };

  @computed
  public get softAuthChange(): boolean {
    return this.softAuth;
  }

  public async handleLogin(callback?: () => void) {
    await this.handleLoginTemplate('/email/change-password', this.emailLoginPasswords, false, {}, callback);
  }

  @action.bound
  public resetPasswordForm() {
    this.emailLoginPasswords = { oldPassword: '', password: '', confirmPassword: '' };
  }

  public async getInitialPasswordChangeProps() {
    try {
      this.resetPasswordForm();
      const response = await API.get(`/email/initialize-pw-change${this.routeStore.formForwardParams}`);
      this.softAuth = response.data.params?.softAuth ?? false;
    } catch (e: Error | string | any) {
      this.handleError(e);
    }
  }

  @action.bound
  public handleChangePasswordModalOpen(isOpen: boolean) {
    this.isChangePasswordModalOpen = isOpen;
  }
}
